// Katalog služeb — oficiální texty dle dokumentu "Apex Detailing – Programy"
// (ceny + délky odpovídají backend/utils/pricing.py)
export const SERVICES = {
  classic: {
    exterior: {
      name: "Exteriér Classic",
      price: 850,
      duration: 60,
      tagline: "Váš vůz vždy čistý a připravený.",
      image: "/images/services/exterior.jpg",
      features: [
        "Šetrné ruční mytí moderní bezoplachovou (rinseless) metodou.",
        "Důkladné očištění kol a oživení vnějších plastových povrchů.",
        "Precizní dosušení laku vysoce savými mikrovláknovými ručníky.",
        "Ideální program pro pravidelnou údržbu a neustále čistý vůz.",
      ],
      detailFeatures: [
        "Ruční mytí šetrnou rinseless metodou (bezoplachová technologie).",
        "Důkladné očištění disků a kol.",
        "Ošetření, vyčištění a obnova vnějších plastových povrchů.",
        "Šetrné dosušení vysoce savými mikrovláknovými ručníky.",
      ],
    },
    interior: {
      name: "Interiér Classic",
      price: 1250,
      duration: 90,
      tagline: "Důkladná péče pro čistý a reprezentativní interiér.",
      image: "/images/services/interior.jpg",
      features: [
        "Kompletní vysátí celého interiéru včetně zavazadlového prostoru.",
        "Hloubkové chemické čištění koberečků a ošetření všech plastů.",
        "Šetrné vyčištění palubní desky, textilních či kožených povrchů.",
        "Křišťálově čistá a perfektně vyleštěná vnitřní skla.",
      ],
      detailFeatures: [
        "Precizní vysátí všech koberečků, podlah a sedadel včetně kufru.",
        "Důkladné vyčištění veškerých interiérových plastů.",
        "Chemické vyčištění podlahových koberečků a zavazadlového prostoru.",
        "Vyčištění a oživení palubní desky.",
        "Šetrné čištění textilních nebo kožených povrchů sedadel.",
        "Perfektní vyleštění vnitřních skel.",
      ],
    },
    complete: {
      name: "Komplet Classic",
      price: 1650,
      duration: 150,
      popular: true,
      tagline: "Péče zevnitř i zvenku v jedné návštěvě.",
      image: "/images/services/complete.jpg",
      features: [
        "Propojení služeb Exteriér Classic a Interiér Classic v jedné návštěvě.",
        "Udržovací péče o čistotu karoserie i reprezentativní vzhled interiéru.",
        "Skvělá volba pro pravidelnou (např. měsíční) údržbu vašeho vozu.",
        "Váš vůz bude vždy perfektně čistý a připravený na každou situaci.",
      ],
      detailFeatures: [
        "Zahrnuje kompletní úkony z programu Exteriér Classic.",
        "Zahrnuje kompletní úkony z programu Interiér Classic.",
        "Ideální pro pravidelnou a efektivní údržbu vozu.",
        "Ušetří čas i peníze díky výhodnému spojení obou služeb.",
      ],
    },
  },
  detailing: {
    exterior: {
      name: "Exteriér Premium",
      price: 1850,
      duration: 120,
      tagline: "Exteriér, který na sebe hrdě upozorní.",
      image: "/images/services/exterior.jpg",
      features: [
        "Chemická dekontaminace (odstranění hmyzu, polétavé rzi a brzdového prachu).",
        "Ruční rozleštění detailerem s příměsí prémiového karnaubského vosku.",
        "Aplikace keramické hydrofobní ochrany laku s výdrží až 6 měsíců.",
        "Hloubková výživa a dlouhodobá impregnace plastů i pneumatik.",
      ],
      detailFeatures: [
        "Ruční mytí ekologickou rinseless metodou nejvyšší kvality.",
        "Bezpečné odstranění hmyzu specializovaným rozpouštědlem.",
        "Šetrné a hloubkové očištění kol.",
        "Chemická dekontaminace laku: odstranění brzdového prachu a polétavé rzi.",
        "Impregnace, ochrana a vysoký lesk pneumatik.",
        "Hloubkové vyživení a dlouhodobá impregnace vnějších plastů.",
        "Nanesení špičkové keramické hydrofobní vrstvy s ochranou na 6 měsíců.",
        "Ruční rozleštění prémiovým detailerem s příměsí brazilského karnaubského vosku pro hluboký lesk.",
        "Finální sušení vysoce savými mikrovláknovými ručníky.",
        "Dokonalé vyleštění všech skel a zrcátek.",
      ],
    },
    interior: {
      name: "Interiér Premium",
      price: 2150,
      duration: 240,
      tagline: "Váš interiér, jak ho ještě neznáte.",
      image: "/images/services/interior.jpg",
      features: [
        "Precizní detailní čištění (spáry, pedály, displeje) profesionálními štětci.",
        "Pokročilá impregnace textilu (odpuzuje tekutiny) a péče o kůži.",
        "Dlouhodobá UV ochrana, oživení a impregnace všech plastových dílů.",
        "Hloubkové chemické čištění podlah i zavazadlového prostoru.",
      ],
      detailFeatures: [
        "Precizní a detailní vysátí všech koberečků, podlah i celého zavazadlového prostoru.",
        "Hloubkové chemické vyčištění koberečků a kufru.",
        "Pečlivé vyčištění veškerých interiérových plastů.",
        "Dlouhodobá impregnace a prémiová UV ochrana plastových povrchů.",
        "Detailní vyčištění palubní desky a výdechů ventilace profesionálními štětci.",
        "Špičkové hloubkové vyčištění textilních a kožených povrchů.",
        "Pokročilá impregnace textilních sedaček (ochranná vrstva odpuzující špínu a tekutiny).",
        "Hloubkové změkčení kůže kondicionérem, ochrana před praskáním a vyblednutím vlivem slunce.",
        "Zaměření na detaily: spáry, pedály, páčky, LCD displeje, bezpečnostní pásy apod.",
        "Dokonalé vyleštění vnitřních i vnějších skel a zrcátek.",
      ],
    },
    complete: {
      name: "Komplet Premium",
      price: 3450,
      duration: 360,
      popular: true,
      tagline: "Kompletní proměna vašeho vozu.",
      image: "/images/services/complete.jpg",
      features: [
        "Dokonalá a bezkompromisní proměna exteriéru i interiéru vozu.",
        "Obsahuje všechny prémiové úkony z programů Exteriér a Interiér Premium.",
        "Prémiová ochrana materiálů: keramika na lak, vosk, impregnace kůže i textilu.",
        "Ideální poměr cena / efekt pro celoroční péči auta.",
      ],
      detailFeatures: [
        "Dokonalý exteriér i precizně ošetřený interiér v rámci jednoho dne.",
        "Zahrnuje veškeré procedury a kroky z programu Exteriér Premium.",
        "Zahrnuje veškeré procedury a kroky z programu Interiér Premium.",
        "Nejvyšší standard péče, dlouhodobá ochrana a maximální důraz na detail.",
        "Nejoblíbenější a nejvýhodnější program v naší nabídce.",
      ],
    },
  },
};

export const ADDITIONAL_SERVICES = [
  { id: "textile_seats_impregnation", name: "Impregnace textilních sedaček", price: 300 },
  { id: "leather_seats_nutrition", name: "Výživa kožených sedaček", price: 300 },
  { id: "mobile_service", name: "Mobilní služba – přijedeme za vámi", price: 0 },
  { id: "pet_hair_removal", name: "Odstranění zvířecích chlupů", price: 200 },
];

export const VEHICLE_TYPES = [
  { id: "osobni", label: "Osobní (střední třída)", surcharge: 0 },
  { id: "suv_mpv", label: "SUV / MPV", surcharge: 0.2 },
  { id: "van", label: "Van", surcharge: 0.3 },
];

// Adresa provozovny (přistavení vozu zákazníkem)
export const STUDIO_ADDRESS = {
  street: "Ježkova 627",
  city: "250 91 Zeleneč",
  full: "Ježkova 627, 250 91 Zeleneč",
  mapsUrl: "https://www.google.com/maps/search/?api=1&query=Je%C5%BEkova%20627%2C%20250%2091%20Zelene%C4%8D",
  mapsEmbedUrl: "https://www.google.com/maps?q=Je%C5%BEkova%20627%2C%20250%2091%20Zelene%C4%8D&output=embed",
};
